<template>
  <div class="my-container">
    <div class="banner-box-swiper">
      <!-- 这里一定要加 (v-if="carouselList.length > 0") 判断 否则 loop 循环就会失效 （使用静态轮播图数据不会出现这种情况）
      原因：动态获取轮播图数据，数据还没拿到，dom已经加载完成，所以loop会失效
       -->
      <swiper v-if="carouselList.length > 0" :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-slide" v-for="item in carouselList" :key="item.id">
          <img class="swiperImg" :src="item.imgUrl" alt=""/>
        </swiper-slide>
      </swiper>
    </div>
    <div class="indicators">
      <div :class="'item ' + (carouselIndex == index ? 'active' : '')" v-for="(_, index) in carouselList.length" :key="index"></div>
    </div>
  </div>
</template>
<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper/src'
import 'swiper/dist/css/swiper.css'

const isMobile = navigator.userAgent.match( // 判断不同端
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
) !== null
let vm = null
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      carouselList: [],
      defaultRotationList: [
        {id: 1, imgUrl: require('@/assets/swiper_02.png')},
        {id: 2, imgUrl: require('@/assets/swiper_01.png')}
      ],
      active: 0,
      carouselIndex: 0,
      // 异形轮播图配置
      swiperOption: {
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0, // slide做3d旋转时Y轴的旋转角度 (默认50).
          stretch:isMobile ? -40 : -100, // 每个slide之间的拉伸值 越大slide靠得越紧.
          depth: 50, // slide的位置深度 值越大z轴距离越远 看起来越小.
          modifier: 1, // depth和rotate和stretch的倍率 相当于(depth*modifier、rotate*modifier、stretch*modifier) 值越大这三个参数的效果越明显(默认1).
          slideShadows: false // 开启slide阴影 (默认 true)
        },
        // 默认选中中间一张
        centeredSlides: true,
        // 无限循环
        loop: true,
        // 自动轮播
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        slideToClickedSlide: true,
        on: {
          slideChange: function () {
            // console.log(this.realIndex)
            vm.carouselIndex = this.realIndex
          }
        }
      }
    }
  },
  created() {
    vm = this
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.getCarouselList()
  },
  methods: {
    _isMobile() {
      let plat = navigator.userAgent.match( // 判断不同端
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return plat;
    },
    // 轮播图
    getCarouselList() {
      // 这里调接口拿轮播图数据 我这里展示的是默认的
      this.carouselList = this.defaultRotationList
    }
  }
}
</script>
<style lang="less" scoped>
.my-container {
  width: 100%;
  height: 610px;
  margin-top: 112px;
  box-sizing: border-box;

  .banner-box-swiper {
    width: 100%;
    height: 434px;
    overflow: hidden;

    .swiper-container {
      height: 434px;
      width: 1354px;
      overflow: visible;

      .swiper-slide {
        text-align: center;
        background: #fff;
        transition: 300ms;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .swiperImg{
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
  }

  .indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 71px 0 79px;

    .item {
      width: 89px;
      height: 24px;
      border-radius: 30px;
      background: rgba(255, 255, 255, 0.7);
      margin: 0rem 15px;
      border: 3px solid #3699FF;
      box-sizing: border-box;

      &.active {
        background: #3699FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/swiperThree.vue